module.exports = __webpack_public_path__ + "8a979d33c7204b6d899cc24245f76328.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/07-Betsolutions-Captain-of-Pirates.png
// module id = 1729
// module chunks = 2